import React, { useMemo } from 'react';

function useDateInput(showTime?: boolean) {

  const dateOptions = useMemo(() => {
    return { type: "date", displayFormat: `dd-MM-yyyy ${showTime ? 'HH:mm' : ''}` }
    // return {type: "date", displayFormat: `yyyy-MM-dd ${showTime ? 'hh:MM:ss' : ''}`}
  }, [])

  return { dateOptions }
}

export default useDateInput;